module.exports = __webpack_public_path__ + "images/file_icons_v2/json-b3af9b88cde99b0b3b379ee2b3435ba5.svg";